// THIS FILE IS GENERATED. DO NOT MODIFY IT MANUALLY.
export { panelPlugin } from '@atlaskit/editor-plugin-panel';
export type {
	PanelPlugin,
	PanelPluginConfig,
	PanelPluginOptions,
} from '@atlaskit/editor-plugin-panel';
